import { CheckIcon, ModalDialog, Mtds } from 'prove-common'

type ConfirmUpdateModalProps = {
  isOpen: boolean
  heading?: string
  description?: string
  buttonLabel?: string
}

export const ConfirmUpdateModal = ({
  isOpen,
  heading = 'Ny oppdatering tilgjengelig',
  description = 'En ny versjon av applikasjonen er tilgjengelig.',
  buttonLabel = 'Oppdater nå'
}: ConfirmUpdateModalProps) => (
  <ModalDialog closedby='closerequest' open={isOpen}>
    <Mtds.Prose>
      <Mtds.Heading>{heading}</Mtds.Heading>
      <p>{description}</p>
      <Mtds.Flex style={{ paddingTop: 'var(--mtds-8)' }}>
        <Mtds.Button
          data-variant='primary'
          onClick={() => globalThis.location.reload()}
        >
          <CheckIcon />
          {buttonLabel}
        </Mtds.Button>
      </Mtds.Flex>
    </Mtds.Prose>
  </ModalDialog>
)
